import { render } from "./ProductPageLayout.vue?vue&type=template&id=cbe4f25a&scoped=true"
import script from "./ProductPageLayout.vue?vue&type=script&lang=js"
export * from "./ProductPageLayout.vue?vue&type=script&lang=js"

import "./ProductPageLayout.vue?vue&type=style&index=0&id=cbe4f25a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.21_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbe4f25a"]])

export default __exports__